export class GeoModel {
    lat: number;
    lng: number;
    degrees?: number;
    velocity?: number;
    last?: string;
    direccion?: string;
    constructor(latitud, longitud, degrees, velocity, last) {
        this.lat = latitud;
        this.lng = longitud;
        this.degrees = degrees;
        this.velocity = velocity;
        if (last) {
            const [datePart, timePart] = last.split(' ');
            const [day, month, year] = datePart.split('/');
            const [hours, minutes, seconds] = (timePart || '').split(':');
            const d = new Date(+year, +month - 1, +day, +hours || 0, +minutes || 0, +seconds || 0);
            this.last = isNaN(d.getTime()) ? last : d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
        } else {
            this.last = last;
        }
    }
}